import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicesPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

function ServicesPage() {
  const navigate = useNavigate();

  return (
    <div className="services-page">
      <Header />
      
      <section className="services-hero">
        <div className="services-hero-container">
          <h1 className="services-hero-title">
            Nos Services Digitaux Assistés par <span className="services-hero-highlight">l'intelligence Artificielle</span>
          </h1>
          <p className="services-hero-intro">
            Chez Viviworks.IA, nous combinons expertise humaine et intelligence artificielle pour créer des solutions digitales uniques.
          </p>
          <p className="services-hero-intro">
            De la conception de sites web à la rédaction et au design graphique, chaque projet est optimisé par l'IA pour offrir performance, créativité et impact durable.
          </p>
        </div>
      </section>

      <section className="services-content">
        <div className="services-content-wrapper">
          <div className="services-image-left">
            <img src="/slide1S.png" alt="Viviworks.IA" className="services-decorative-image-left" />
          </div>

          <div className="services-content-container">
            <div className="services-grid-page">
              <div className="service-card-page service-card-pink-large">
                <h3 className="service-card-page-title">Développement Web Intelligent</h3>
                <p className="service-card-page-text">
                  Nous concevons des sites web modernes, performants et intelligents, pensés pour séduire vos visiteurs et optimiser l'expérience utilisateur.
                </p>
                <p className="service-card-page-text">
                  Grâce à l'intelligence artificielle, nous analysons les comportements des visiteurs, adaptons les interfaces et créons des expériences de navigation fluides et évolutives.
                </p>
                <p className="service-card-page-text">
                  Chaque projet est développé avec les dernières technologies du web : sites vitrines, e-commerce, applications web sur mesure, le tout optimisé pour la performance, la rapidité et l'évolutivité.
                </p>
                <p className="service-card-page-text">
                  Notre approche "web intelligent" vous garantit un site capable de s'adapter à l'analyse automatisée des données.
                </p>
                <button className="service-card-page-button" onClick={() => navigate('/developpement-web')}>En savoir plus</button>
              </div>

              <div className="service-cards-right">
                <div className="service-card-page service-card-white">
                  <h3 className="service-card-page-title">Référencement & Rédaction SEO assistés par IA</h3>
                  <p className="service-card-page-text">
                    Boostez votre visibilité en ligne grâce à des stratégies de référencement précises par l'intelligence artificielle.
                  </p>
                  <p className="service-card-page-text">
                    Nos outils d'IA vous permettent d'identifier les mots clés les plus pertinents, d'analyser la concurrence en temps réel et d'optimiser vos contenus.
                  </p>
                  <p className="service-card-page-text">
                    En parallèle, notre rédaction combine créativité humaine et analyse sémantique avancée pour produire des textes engageants et parfaitement alignés avec les attentes de vos clients.
                  </p>
                  <p className="service-card-page-text">
                    Résultat : plus de trafic, une meilleure conversion et une image de marque renforcée.
                  </p>
                  <button className="service-card-page-button service-card-page-button-dark" onClick={() => navigate('/referencement')}>En savoir plus</button>
                </div>

                <div className="service-card-page service-card-pink-small">
                  <h3 className="service-card-page-title">Design Graphique & Branding créatifs</h3>
                  <p className="service-card-page-text">
                    Nous concevons des identités visuelles, logos, chartes graphiques et supports de communication qui allient originalité, cohérence et performance.
                  </p>
                  <p className="service-card-page-text">
                    Notre objectif : créer une image de marque forte, mémorable et adaptée à l'ère du digital intelligent.
                  </p>
                  <button className="service-card-page-button" onClick={() => navigate('/design-graphique')}>En savoir plus</button>
                </div>
              </div>
            </div>
          </div>

          <div className="services-image-right">
            <img src="/slide1Q.png" alt="Viviworks.IA" className="services-decorative-image-right" />
          </div>
        </div>
      </section>

      <section className="services-why-ai">
        <div className="services-why-ai-container">
          <h2 className="services-why-ai-title">
            <span className="services-why-ai-highlight">Pourquoi l'IA ?</span> Explication du rôle de l'IA dans notre méthodologie
          </h2>
          <p className="services-why-ai-text">
            Chez Viviworks.IA, l'intelligence artificielle n'est pas un simple outil, mais le cœur de notre démarche. 
            Nous l'intégrons à chaque étape de vos projets, de la recherche à la création jusqu'à l'optimisation.
          </p>
          <p className="services-why-ai-text">
            Plutôt que de rivaliser avec vous, l'IA devient un partenaire qui amplifie votre vision et votre expertise. 
            Elle analyse, suggère et affine, vous permettant de prendre des décisions éclairées et d'atteindre vos objectifs plus rapidement.
          </p>
          <p className="services-why-ai-text">
            L'IA nous permet d'offrir précision technique, créativité augmentée et performance mesurable, pour offrir à chaque client 
            une stratégie digitale à la fois humaine et intelligente.
          </p>
          <button className="services-why-ai-button">Découvrir notre approche</button>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default ServicesPage;

